/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import VideoControls from './video-controls';

export * from './video-controls.props';

/**
 * Exporting the PlayPauseTrigger.
 */
export { VideoControls };
